import { goToSection } from 'app/utils';
import { ButtonIcon, Hr, Section } from 'components';
import { DashboardAreaColorEnum, DashboardVisualizationTypeEnum } from 'features/dashboard-new';

interface NextSheetProps {
  nextSheetUuid?: string;
  dashboardAreaColor: DashboardAreaColorEnum;
  dashboardVisualizationType: DashboardVisualizationTypeEnum;
}

const NextSheet = ({ nextSheetUuid, dashboardAreaColor, dashboardVisualizationType }: NextSheetProps) => {
  const theme =
    dashboardAreaColor === DashboardAreaColorEnum.Dark
      ? 'dark'
      : dashboardVisualizationType === DashboardVisualizationTypeEnum.Cinema
      ? 'dark'
      : 'light';

  return (
    <>
      {nextSheetUuid && <Hr m={0} color={theme === 'dark' ? 'dark_400' : 'primary_10'} />}

      <Section position="relative">
        {nextSheetUuid ? (
          <ButtonIcon
            bg="primary_400"
            bgHover="navbarBg"
            color="navbarBg"
            colorHover="white"
            width={44}
            height={44}
            borderRadius={22}
            position="absolute"
            icon="arrowDown"
            style={{ left: 0, transform: 'translateY(-50%)' }}
            onClick={() => goToSection(`dashboard-area-${nextSheetUuid}`)}
          />
        ) : (
          <ButtonIcon
            bg="primary_400"
            bgHover="navbarBg"
            color="navbarBg"
            colorHover="white"
            width={44}
            height={44}
            borderRadius={22}
            position="absolute"
            icon="arrowUp"
            style={{ right: 0, transform: 'translateY(-50%)' }}
            onClick={() => goToSection(`root`)}
          />
        )}
      </Section>
    </>
  );
};

export default NextSheet;
